import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    Filter,
    TextInput,
    SelectInput,
    ReferenceInput,
    AutocompleteInput,
    EditButton,
    ShowButton,
    DeleteButton,
    useListContext,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { CUSTOM_FIELD_TYPES_CHOICES } from '../../../../config/api';

const CustomFieldFilter = props => (
    <Filter {...props}>
        <ReferenceInput
            source="client_id"
            reference="clients"
            label="Cliente"
            sort={{ field: 'name', order: 'ASC' }}
            perPage={1000}
            alwaysOn
        >
            <AutocompleteInput
                optionText="name"
                filterToQuery={searchText => ({ name: searchText })}
            />
        </ReferenceInput>
        <TextInput source="name" />
        <SelectInput source="type" choices={CUSTOM_FIELD_TYPES_CHOICES} />
    </Filter>
);

const EmptyGrid = () => {
    const { filterValues } = useListContext();
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={6} gap={2}>
            <FilterListIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
            <Typography variant="h6" color="text.secondary">
                {filterValues.client_id
                    ? 'Este cliente no tiene campos editables.'
                    : 'Selecciona un cliente en el filtro superior para ver sus campos editables.'}
            </Typography>
        </Box>
    );
};

const CustomFieldList = () => (
    <List exporter={false} filters={<CustomFieldFilter />} empty={false} sort={{ field: 'id', order: 'ASC' }}>
        <Datagrid rowClick="show" empty={<EmptyGrid />}>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <TextField source="type" />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export default CustomFieldList;
